import React from 'react'
import FacetGroup from 'ui-shared/Facets/Wrappers/FacetGroup'
import PricingFacet from 'ui-shared/Facets/Wrappers/PricingFacet'

const UpsellingFacetSection: React.FC = () => {
  return (
    <>
      <FacetGroup />
      <PricingFacet initialValue="perPerson" />
    </>
  )
}

export default UpsellingFacetSection
